import Service from './service';
import logger from "../../logger";
import dates from "../../dates";


export default class ConnectivityService extends Service {
  constructor(service, address_details) {
    super(service);
    this.address_details = address_details;
        this.speed_info_map = {
      speed_250_sym: {
        label: '250Mbps',
        description: 'Perfect for the individual with average usage.',
        color: 'xm-y-bg'
      },
      speed_1000_sym: {
        label: '1Gbps',
        description: 'All the bandwidth a family needs for streaming, gaming, and more.',
        color: 'xm-b-bg'
      },
      speed_2000_sym: {
        label: '2Gbps',
        description: 'A bigger pipe for a bigger family or work-from-home professional.',
        color: 'xm-g-bg'
      },
      speed_2500_sym: {
        label: '2.5Gbps',
        description: 'A bigger pipe for a bigger family or work-from-home professional.',
        color: 'xm-g-bg'
      },
      speed_10000_sym: {
        label: '10Gbps',
        description: 'Serious users only. Make sure you have a router powerful enough for this much speed.',
        color: 'xm-r-bg'
      }
    };
    this.active_speed_option = null;
    this.install_info_map = {
      'basic': {
        'label': 'Standard install',
        'description': 'Cabling run up to 45’ to wireless router, taking up to 2 hours.',
        'sub_description': 'covers most installations'},
      'advanced': {
        'label': 'Advanced install',
        'description': 'Cabling run up to 150’ to wireless router, taking up to 4 hours.',
        'sub_description': 'not common'}};
    this.setSpeedStrings();
    this.setOrderSummaryStrings();
    logger.debug('conn service', this.service);
  }

  setSpeedStrings () {
    for (let speed_option of this.service.speed_options) {
      speed_option.label = this.speed_info_map[speed_option.speed_id].label;
      speed_option.description = this.speed_info_map[speed_option.speed_id].description;
      speed_option.color = this.speed_info_map[speed_option.speed_id].color;
    }
  }

  getRateTermString(promo, rate, legal) {
    if (!rate) {
    }
    if (promo.rate_term === 1){
      if (legal) {
        return 'one FREE month';
      }
      return `First month ${rate > 0 ? '$' + rate : 'FREE'}`;
    }
    else {
      let word_map = {1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight',
                           9: 'nine', 10: 'ten', 11: 'eleven', 12: 'twelve'};
      let rate_period_map = {'monthly': 'month', 'yearly': 'year'};
      let suffix = promo.rate_term > 1 ? 's' : '';
      if (legal) {
        if (!rate) {
          return `${word_map[promo.rate_term]} FREE ${rate_period_map[promo.rate_period]}${suffix}`;
        }
        return `$${rate} per ${rate_period_map[promo.rate_period]} for ${word_map[promo.rate_term]} ${rate_period_map[promo.rate_period]}${suffix}`;
      }
      return `First ${word_map[promo.rate_term]} ${rate_period_map[promo.rate_period]}${suffix} ${rate > 0 ? '$' + rate : 'FREE'}`;
    }
  }

  setPromoOrderSummaryStrings() {
    for (let speed_option of this.service.speed_options) {
      for (let promo of speed_option.billing.promos) {
        promo.legal_label = promo.description;
        let variable_string = promo.rate_mode === 'variable' ? ` Up to $${promo.rate_max} value.` : '';
        let one_time_string = !!promo.rate_term ? ' One-time use only.' : '';
        let expire_string = promo.expiration_date ? ` This offer expires on: ${dates.isoDateStringToReadable(promo.expiration_date)}.` : '';
        let location_string = '';
        if (promo.name.includes('wv_online_promo')) {
          location_string = ' Applies to West Valley City residents only.';
        }
        let promo_couple_string = ' This offer cannot be used in combination with other promotions or discounts.';
        if (speed_option.billing.promos.length > 1) {
          let other_promo_names = speed_option.billing.promos.filter(x => x.name !== promo.name).map(x => x.description);
          let other_promo_string = other_promo_names.length > 1 ? other_promo_names.join(', ') : other_promo_names[0];
          promo_couple_string = ` This offer cannot be combined with other promotional offers, with the exception of the ${other_promo_string} promotion${other_promo_names.length > 1 ? 's' : ''}.`
        }
        promo.legal_description = `XMission will automatically credit ${this.getRateTermString(promo, promo.rate === speed_option.billing.prices[0].rate ? null : promo.rate, true)} of XMission Fiber service to your account upon installation and activation.${variable_string}${location_string} This offer does not include additional service fees or hardware costs.${promo_couple_string} Limit of one per household. Applies to new XMission customers only.${one_time_string}${expire_string}`;
      }
    }
  }

  setOrderSummaryStrings() {
    this.setPromoOrderSummaryStrings();
  }

  speedOptions () {
    return this.service.speed_options;
  }

  setActiveSpeedOption(speed_id) {
    let speed_option = this.speedOptions().filter(x => (x.speed_id === speed_id));
    this.active_speed_option = speed_option.length === 1 ? speed_option[0] : null;
    logger.debug('setActiveSpeedOption', speed_id, this.active_speed_option)
  }

  getActiveSpeedOption() {
    return this.active_speed_option;
  }

  addActiveSpeedOptionToCart() {
    return this.order_summary.addServiceOptionToCart(this.getActiveSpeedOption());
  }

  installationOptions () {
    let install_options = JSON.parse(JSON.stringify(this.service.installation_options));
    for (let install_option of install_options) {
      let install_info = this.install_info_map[install_option.installation_type];
      install_option.label = install_info.label;
      install_option.description = install_info.description;
      install_option.sub_description = install_info.sub_description;
    }
    return install_options;
  }

  monthlyPriceFeeServiceOptionBreakdownString(speed_option) {
    let costs_by_provider = this.order_summary.grossCostsPerProvider(speed_option);
    logger.debug('costs by provider', costs_by_provider)
    let breakdown_string = `$${costs_by_provider.xmission.cost} ${costs_by_provider.xmission.provider.label}`;
    if (Object.keys(costs_by_provider).length === 2) {
      for (let key in costs_by_provider) {
        if (key === 'xmission') {
          continue;
        }
        breakdown_string = `${breakdown_string} + $${costs_by_provider[key].cost} ${costs_by_provider[key].provider.label}`;
      }
    }
    return breakdown_string;
  }

  grossServiceOptionMonthlyCost(speed_option) {
    return this.order_summary.grossServiceOptionXMissionMonthlyCost(speed_option);
  }

  onlinePromo(speed_option) {
    let promos = speed_option.billing.promos.filter(x => x.featured);
    if (promos.length === 1){
      return promos[0];
    }
    return null;
  }

  grossOneTimeXMissionCost(speed_option) {
    let online_promo = this.onlinePromo(speed_option);
    let monthly_cost = this.order_summary.grossServiceXMissionMonthlyCost() + this.order_summary.grossServiceOptionXMissionMonthlyCost(speed_option);
    // todo make this less shitty
    let online_promo_rate = Boolean(online_promo) ? online_promo.rate: 0;
    return monthly_cost - online_promo_rate;
  }

}



// WEBPACK FOOTER //
// ./src/lib/ssu/input_models/connectivity-service.js